import { useLang } from "../../i18n/LangContext";
import { Field, inputProps } from "../site/Primitives";

export const PhoneOptinFields = ({ prefix, values, errors, setVal }) => {
  const { t } = useLang();
  const d = t.dossier;
  return (
    <>
      <Field id={`${prefix}-phone`} label={d.phone} error={errors.phone}>
        <input type="tel" autoComplete="tel" placeholder={d.phonePh} {...inputProps(`${prefix}-phone`, errors.phone)} value={values.phone} onChange={(e) => setVal("phone", e.target.value)} />
      </Field>
      <div className="f-field" style={{ justifyContent: "flex-end" }}>
        <label className="check-row" htmlFor={`${prefix}-optin`}>
          <input type="checkbox" id={`${prefix}-optin`} checked={values.whatsapp_optin} onChange={(e) => setVal("whatsapp_optin", e.target.checked)} data-testid={`${prefix}-optin-checkbox`} />
          <span>{d.optin}</span>
        </label>
      </div>
    </>
  );
};

export const phoneRules = (values) => {
  const rules = { phone: values.phone ? ["intl"] : [] };
  if (values.whatsapp_optin) rules.phone = ["required", "intl"];
  return rules;
};

export const toPayloadPhone = (v) => (v ? v.replace(/[\s().-]/g, "") : null);
